import { useEffect, useState } from 'react';

import { useAuthState } from '~/auth';

import { SalesforceUserLicensePoolAccess, getSalesforceUserLicensePoolAccess } from '~/services/SalesforceService';

type UseSalesforceUserLicenseState = {
  loading: boolean;
  userLicensePoolAccessData: SalesforceUserLicensePoolAccess;
  error: string | null;
  refresh: () => void;
};

export const useGetSalesforceUserLicense = (): UseSalesforceUserLicenseState => {
  const { user } = useAuthState();
  const [state, setState] = useState({
    loading: false,
    userLicensePoolAccessData: null,
    error: null,
  });

  const loadSalesforceUserLicense = async () => {
    if (!user?.email) {
      setState({
        loading: false,
        userLicensePoolAccessData: null,
        error: 'User email not available',
      });
      return;
    }

    setState({
      loading: true,
      userLicensePoolAccessData: null,
      error: null,
    });

    try {
      const response = await getSalesforceUserLicensePoolAccess(user.email);
      setState({
        loading: false,
        userLicensePoolAccessData: response,
        error: null,
      });
    } catch (error: any) {
      setState({
        loading: false,
        userLicensePoolAccessData: null,
        error: error.message || 'Failed to get Salesforce user license',
      });
    }
  };

  const refresh = () => {
    loadSalesforceUserLicense();
  };

  useEffect(() => {
    void loadSalesforceUserLicense();
  }, [user?.email]);

  return {
    ...state,
    refresh,
  };
};
